import { defineComponent as w, computed as B, useSlots as V, openBlock as r, createBlock as S, unref as a, normalizeStyle as T, normalizeClass as t, withCtx as i, createElementVNode as c, renderSlot as s, createElementBlock as b, createCommentVNode as m, createTextVNode as p, toDisplayString as y, createVNode as d } from "vue";
import C from "../../common/VButton/VButton.vue.mjs";
import { VButtonVariants as h } from "../../../packages/vsimple-ui/types/VButton.mjs";
import R from "../../../icons/CancelIcon.vue.mjs";
import O from "../../../icons/CheckedIcon.vue.mjs";
import z from "../../../icons/CloseIcon.vue.mjs";
import { VueFinalModal as F } from "vue-final-modal";
const U = /* @__PURE__ */ w({
  __name: "VBaseModal",
  props: {
    title: { default: "" },
    cancelButtonText: { default: "Cancel" },
    cancelButtonDisabled: { type: Boolean, default: !1 },
    submitButtonDisabled: { type: Boolean, default: !1 },
    submitButtonText: { default: "Submit" },
    isModalShow: { type: Boolean },
    loading: { type: Boolean, default: !1 },
    closeOnOverlayClick: { type: Boolean, default: !0 },
    maxWidth: { default: "396px" },
    withCloseIcon: { type: Boolean, default: !0 },
    closeIconCustomEvent: { type: Boolean, default: !1 },
    hideFooter: { type: Boolean, default: !1 },
    hideSubmit: { type: Boolean, default: !1 },
    btnsAlignRight: { type: Boolean, default: !1 },
    escToClose: { type: Boolean, default: !0 },
    zIndexFn: { type: Function, default: ({ index: f }) => 1e3 + 2 * f },
    showRequiredStar: { type: Boolean, default: !1 },
    dataTest: {}
  },
  emits: ["update:is-modal-show", "cancel", "click:closeIcon", "submit", "closed"],
  setup(f, { emit: k }) {
    const n = f, o = k, v = B({
      get() {
        return n.isModalShow;
      },
      set(e) {
        o("update:is-modal-show", e);
      }
    }), $ = B(() => n.closeOnOverlayClick ? !n.loading : n.closeOnOverlayClick), g = V(), I = () => {
      if (n.closeIconCustomEvent)
        return o("click:closeIcon");
      o("cancel");
    };
    return (e, l) => (r(), S(a(F), {
      modelValue: v.value,
      "onUpdate:modelValue": l[2] || (l[2] = (u) => v.value = u),
      class: t(e.$style["v-base-modal"]),
      "click-to-close": $.value,
      "esc-to-close": e.escToClose && !e.loading,
      "focus-trap": !1,
      "z-index-fn": e.zIndexFn,
      "data-test": e.dataTest,
      style: T({
        "--modal-max-width": e.maxWidth
      }),
      onClosed: l[3] || (l[3] = (u) => o("closed"))
    }, {
      default: i(() => [
        c("div", {
          class: t(e.$style["v-base-modal__header"])
        }, [
          s(e.$slots, "modal-title", {}, () => [
            c("h3", {
              class: t([
                e.$style["v-base-modal__title"],
                {
                  [e.$style["v-base-modal__title--with-close"]]: e.withCloseIcon
                }
              ])
            }, [
              e.showRequiredStar ? (r(), b("span", {
                key: 0,
                class: t(e.$style["v-base-modal__title-required-star"])
              }, " * ", 2)) : m("", !0),
              p(" " + y(e.title), 1)
            ], 2)
          ]),
          s(e.$slots, "modal-extra-btn"),
          e.withCloseIcon ? (r(), b("div", {
            key: 0,
            class: t(e.$style["v-base-modal__close-icon"]),
            onClick: I
          }, [
            d(z)
          ], 2)) : m("", !0)
        ], 2),
        c("div", {
          class: t(e.$style["v-base-modal__body"])
        }, [
          s(e.$slots, "default")
        ], 2),
        e.hideFooter ? m("", !0) : (r(), b("div", {
          key: 0,
          class: t([
            e.$style["v-base-modal__buttons"],
            {
              [e.$style["v-base-modal__buttons--right"]]: e.btnsAlignRight,
              [e.$style["v-base-modal__buttons--single"]]: e.hideSubmit,
              [e.$style["v-base-modal__buttons--triple"]]: a(g)["footer-extra-btn"]
            }
          ])
        }, [
          s(e.$slots, "cancel-btn", {}, () => [
            d(a(C), {
              variant: a(h).PRIMARY_OUTLINE,
              fill: "",
              disabled: e.loading || e.cancelButtonDisabled,
              onClick: l[0] || (l[0] = (u) => o("cancel"))
            }, {
              icon: i(() => [
                d(R)
              ]),
              default: i(() => [
                p(" " + y(e.cancelButtonText), 1)
              ]),
              _: 1
            }, 8, ["variant", "disabled"])
          ]),
          s(e.$slots, "footer-extra-btn"),
          e.hideSubmit ? m("", !0) : s(e.$slots, "submit-btn", { key: 0 }, () => [
            d(a(C), {
              variant: a(h).PRIMARY,
              loading: e.loading,
              disabled: e.submitButtonDisabled,
              fill: "",
              onClick: l[1] || (l[1] = (u) => o("submit"))
            }, {
              icon: i(() => [
                d(O)
              ]),
              default: i(() => [
                p(" " + y(e.submitButtonText), 1)
              ]),
              _: 1
            }, 8, ["variant", "loading", "disabled"])
          ])
        ], 2))
      ]),
      _: 3
    }, 8, ["modelValue", "class", "click-to-close", "esc-to-close", "z-index-fn", "data-test", "style"]));
  }
});
export {
  U as default
};
